/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    Row,
    Col,
} from '@bootstrap-styled/v4';

import {
    FormGroup,
    SelectProductCheckboxContainer,
    Label,
} from '../../../theme/components';


const SelectProductCheckboxes = ({
    // selectproduct,
    id,
    label,
    description,
    items,
    input,
    name,
    meta: { error, pristine, touched },
    handleSubmit,
    // onBlur,
    ...otherProps
}) => (

    <FormGroup role="group" aria-labelledby={id}>

        <SelectProductCheckboxContainer>
            <Row>
                <Col xs="12">
                    <div className="select-product-checkboxes">
                        {
                            items.map((o) => (
                                <div key={`${id}-${o.id}`} className={`select-product-checkbox ${o.productstyle}`}>
                                    <div className="checkbox-body">
                                        <input
                                            name={name}
                                            id={`${id}-${o.id}`}
                                            type="checkbox"
                                            {...input}
                                            {...otherProps}
                                            value={o.name}
                                            checked={input.value.indexOf(o.name) !== -1}
                                            onChange={(event) => {
                                                const newValue = [...input.value];
                                                if (event.target.checked) {
                                                    newValue.push(o.name);
                                                } else {
                                                    newValue.splice(newValue.indexOf(o.name), 1);
                                                }
                                                return input.onChange(newValue);
                                            }}
                                        />
                                        <Label
                                            onClick={(e) => {
                                                // e.preventDefault();
                                                setTimeout(() => handleSubmit(), 0);
                                                // setTimeout(() => onBlur(), 0);
                                            }}
                                            htmlFor={`${id}-${o.id}`}
                                        >
                                            <span className="title">{o.title}</span>
                                            <span className="label">{o.label}</span>
                                        </Label>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </Col>
            </Row>
        </SelectProductCheckboxContainer>
    </FormGroup>

);

SelectProductCheckboxes.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    input: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.arrayOf(PropTypes.object),
    // eslint-disable-next-line react/forbid-prop-types
    meta: PropTypes.object,
    id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string,
    handleSubmit: PropTypes.func,
    onBlur: PropTypes.func,
};

SelectProductCheckboxes.defaultProps = {
    input: {},
    id: '',
    label: '',
    description: '',
    items: [{}, {}],
    name: '',
    meta: {},
    handleSubmit: () => {},
    onBlur: () => {},
};

export default SelectProductCheckboxes;
